import { useLayoutEffect, useState, type RefObject } from "react";

/** Measures draft text against its expanded width, including soft wrapping. */
export function useComposerMultilinePrompt(formRef: RefObject<HTMLFormElement | null>): boolean {
  const [multiline, setMultiline] = useState(false);
  useLayoutEffect(() => {
    const form = formRef.current;
    const body = form?.querySelector<HTMLElement>('[data-chat-composer-body="true"]');
    const editor = form?.querySelector<HTMLElement>('[data-testid="composer-editor"]');
    const surface = form?.querySelector<HTMLElement>('[data-chat-composer-surface="true"]');
    if (!body || !editor || !surface) return;
    const measure = () => {
      if (!editor.clientWidth) return;
      const style = getComputedStyle(body);
      const width =
        surface.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      const lineHeight = parseFloat(getComputedStyle(editor).lineHeight);
      const range = document.createRange();
      range.selectNodeContents(editor);
      const bounds = range.getBoundingClientRect();
      setMultiline(bounds.height > lineHeight + 1 || bounds.width > width + 1);
    };
    measure();
    const resize = new ResizeObserver(measure);
    resize.observe(surface);
    resize.observe(editor);
    const mutation = new MutationObserver(measure);
    mutation.observe(editor, { childList: true, characterData: true, subtree: true });
    return () => {
      resize.disconnect();
      mutation.disconnect();
    };
  }, [formRef]);
  return multiline;
}
